<layout>
    <ng-container ngProjectAs="centerRegion">
        <docs></docs>
    </ng-container>
</layout>
